import { render, staticRenderFns } from "./CombatLog.vue?vue&type=template&id=aefa97cc&scoped=true&"
import script from "./CombatLog.vue?vue&type=script&lang=js&"
export * from "./CombatLog.vue?vue&type=script&lang=js&"
import style0 from "./CombatLog.vue?vue&type=style&index=0&id=aefa97cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefa97cc",
  null
  
)

export default component.exports